<div class="flex items-center space-x-2">
  <!-- <label [for]="sliderId" class="select-none">{{ label }}</label> -->
  <input
    type="range"
    [id]="sliderId"
    class="slider"
    [min]="min"
    [max]="max"
    [(ngModel)]="value"
    (input)="onValueChange.emit(value)"
    class="form-range appearance-none w-full rounded-lg h-5 p-0 bg-gray-100 focus:outline-none focus:ring-0 focus:shadow-none"
  />
</div>
